module.exports = __webpack_public_path__ + "static/media/unionpay.c9ce5192.svg";